// extracted by mini-css-extract-plugin
module.exports = {"controller":"Controller_controller__w71Ij"};